/* eslint-disable no-restricted-globals */
import {
    Divider,
    Drawer as MUIDrawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    useTheme,
    Box,
    Collapse,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import clsx from 'clsx';

import AssignmentIcon from '@mui/icons-material/Assignment';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import CardTravelOutlinedIcon from '@mui/icons-material/CardTravelOutlined';
import EmojiPeopleOutlinedIcon from '@mui/icons-material/EmojiPeopleOutlined';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { withRouter } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentIcon from '@mui/icons-material/Payment';
import CommuteIcon from '@mui/icons-material/Commute';
import CssBaseline from '@mui/material/CssBaseline';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { AddLocationAltOutlined, PeopleOutlined, ShareLocationOutlined } from '@mui/icons-material';
import { useAuth } from 'react-oidc-context';
import { useDispatch } from 'react-redux';
import SettingsIcon from '@mui/icons-material/Settings';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import BuildIcon from '@mui/icons-material/Build';
import PasswordIcon from '@mui/icons-material/Password';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import TuneIcon from '@mui/icons-material/Tune';
import InventoryIcon from '@mui/icons-material/Inventory';
import ChecklistIcon from '@mui/icons-material/Checklist';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SavingsIcon from '@mui/icons-material/Savings';
import { jwtDecode } from 'jwt-decode';
/* const useStyles = makeStyles({
    drawer: {
        width: '320px', // aqui se ajusta el espacio entre el sidemenu y el Grid con las formas
    },
});
*/

const drawerWidth = 280;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
}));

function SideMenu(props) {
    const { history, location } = props;
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [openLiq, setOpenLiq] = React.useState(false);
    const [openTaller, setOpenTaller] = React.useState(false);
    const [openControlBancos, setOpenControlBancos] = React.useState(false);
    const auth = useAuth();

    const { pathname } = location;

    // Auto-expand accordion when navigating directly to a sub-route
    useEffect(() => {
        if (['/gasolina', '/gps', '/casetas'].includes(pathname)) setOpen(true);
        if (['/liquidacionvi', '/liquidacionop', '/liquidacionAdmin', '/referenciados', '/reporteUtilidad', '/gastosExtra', '/pagoOperadores', '/pagoAdmin'].includes(pathname)) setOpenLiq(true);
        if (['/mantenimiento', '/registroMateriales', '/historialMtto', '/reporteMtto'].includes(pathname)) setOpenTaller(true);
        if (['/movimientos-bancarios', '/control-ingresos'].includes(pathname)) setOpenControlBancos(true);
    }, [pathname]);

    const theme = useTheme();
    const [openMenu, setOpenMenu] = React.useState(true);

    const handleDrawerOpen = () => {
        setOpenMenu(true);
    };

    const handleDrawerClose = () => {
        setOpenMenu(false);
    };

    const operaciones = [
        {
            text: 'Historial',
            icon: <CardTravelOutlinedIcon />,
            path: '/viajes',
            onClick: () => history.push('/viajes'),
            groups: ['Trafico', 'Administradores', 'Contabilidad', 'Monitoreo', 'Estandar', 'Facturacion'],
        },
        {
            text: 'Viaje',
            icon: <CardTravelOutlinedIcon />,
            path: '/viaje',
            onClick: () => history.push('/viaje'),
            groups: ['Trafico', 'Administradores', 'Estandar', 'Facturacion', 'Monitoreo'],
        },
        {
            text: 'Carga Archivos',
            icon: <BackupOutlinedIcon />,
            path: '/carga',
            onClick: () => history.push('/carga'),
            groups: ['Trafico', 'Administradores', 'Estandar'],
        },
        {
            text: 'Cambiar Contraseña',
            icon: <PasswordIcon />,
            path: '/Password',
            onClick: () => history.push('/Password'),
            groups: ['Administradores'],
        },
        {
            text: 'Parámetros Genéricos',
            icon: <TuneIcon />,
            path: '/generic-parameters',
            onClick: () => history.push('/generic-parameters'),
            groups: ['SuperAdmin'],
        },
    ];

    const catalogos = [
        {
            text: 'Clientes',
            icon: <EmojiPeopleOutlinedIcon />,
            path: '/clientes',
            onClick: () => history.push('/clientes'),
            groups: ['Contabilidad', 'Administradores', 'Estandar', 'Facturacion'],
        },
        {
            text: 'Bancos',
            icon: <AccountBalanceIcon />,
            path: '/bancos',
            onClick: () => history.push('/bancos'),
            groups: ['Administradores', 'Bancos'],
        },
        {
            text: 'Clasif. Movimientos',
            icon: <CategoryOutlinedIcon />,
            path: '/clasificacion-movimientos',
            onClick: () => history.push('/clasificacion-movimientos'),
            groups: ['Administradores', 'Bancos'],
        },
        {
            text: 'Cuentas Bancarias',
            icon: <AccountBalanceWalletIcon />,
            path: '/cuentas-bancarias',
            onClick: () => history.push('/cuentas-bancarias'),
            groups: ['Administradores', 'Bancos'],
        },
        {
            text: 'Ubicaciones',
            icon: <AddLocationAltOutlined />,
            path: '/ubicaciones',
            onClick: () => history.push('/ubicaciones'),
            groups: ['Contabilidad', 'Administradores', 'Monitoreo', 'Estandar'],
        },
        {
            text: 'Monitoreo',
            icon: <ShareLocationOutlined />,
            path: '/monitoreo',
            onClick: () => history.push('/monitoreo'),
            groups: ['Contabilidad', 'Administradores', 'Monitoreo', 'Estandar'],
        },
        {
            text: 'Unidades',
            icon: <LocalShippingOutlinedIcon />,
            path: '/unidades',
            onClick: () => history.push('/unidades'),
            groups: ['Contabilidad', 'Administradores', 'Monitoreo', 'Estandar'],
        },
        {
            text: 'Operadores',
            icon: <PersonOutlineOutlinedIcon />,
            path: '/operadores',
            onClick: () => history.push('/operadores'),
            groups: ['Contabilidad', 'Administradores', 'Estandar'],
        },
        {
            text: 'Facturas',
            icon: <AttachMoneyIcon />,
            path: '/facturas',
            onClick: () => history.push('/facturas'),
            groups: ['Contabilidad', 'Administradores', 'Estandar', 'Facturacion'],
        },
        {
            text: 'Usuarios',
            icon: <PeopleOutlined />,
            path: '/usuarios',
            onClick: () => history.push('/usuarios'),
            groups: ['Administradores'],
        },
        {
            text: 'Admin',
            icon: <SettingsIcon />,
            path: '/admin',
            onClick: () => history.push('/admin'),
            groups: ['Administradores'],
        },
        {
            text: 'Cerrar Sesion',
            icon: <ExitToAppIcon />,
            path: null,
            onClick: async () => {
                try {
                    await auth.signoutRedirect();
                } catch (error) {
                    console.error('Error during logout:', error);
                    window.location.href = '/';
                }
            },
            groups: ['Administradores', 'Bancos', 'Contabilidad', 'Estandar', 'Facturacion', 'Monitoreo', 'SuperAdmin', 'Trafico'],
        },
    ];

    const handleClick = () => {
        setOpen(!open);
    };

    const handleClickLiq = () => {
        setOpenLiq(!openLiq);
    };

    const handleClickTaller = () => {
        setOpenTaller(!openTaller);
    };

    const handleClickControlBancos = () => {
        setOpenControlBancos(!openControlBancos);
    };

    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        if (!auth.isAuthenticated) {
            setUserInfo(null);
        } else {
            // Get user info
            const ui = jwtDecode(auth?.user?.access_token || '');
            const groups = ui['cognito:groups'] || [];
            setUserInfo({
                ...ui,
                groups,
            });
        }
    }, [auth]);

    useEffect(() => {
        console.log('User Info:', userInfo);
        console.log('Groups:', userInfo?.groups);
    }, [userInfo]);

    if (!userInfo) {
        return (<></>);
    }

    const nombreUsuario = auth.user?.profile?.email || userInfo.username || '';
    return (
        <div className={classes.root}>
            <Box component='span' displayPrint='none'>
                <CssBaseline />
                <AppBar
                    className={clsx(classes.appBar, {
                        [classes.appBarShift]: openMenu,
                    })}
                    position='fixed'
                >
                    <Toolbar>
                        <IconButton
                            aria-label='open drawer'
                            className={clsx(classes.menuButton, openMenu && classes.hide)}
                            color='inherit'
                            edge='start'
                            onClick={handleDrawerOpen}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography noWrap variant='h6'>
                            SIMET
                        </Typography>
                        <Box sx={{ flexGrow: 1 }} />
                        <Box sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 1,
                            minWidth: 0,
                        }}
                        >
                            <AccountCircle sx={{ fontSize: 36 }} />
                            <Typography noWrap variant='subtitle1'>
                                {nombreUsuario}
                            </Typography>
                        </Box>
                    </Toolbar>
                </AppBar>
                <MUIDrawer
                    anchor='left'
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    className={(openMenu ? classes.drawer : classes.hide)}
                    open={openMenu}
                    variant='permanent'
                >
                    <div className={classes.drawerHeader}>
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </div>
                    <Divider />
                    <List>
                        {operaciones
                            .filter((item) => {
                                // Only show if user has at least one of the required groups
                                if (!userInfo?.groups || !item.groups) {
                                    return false;
                                }
                                return item.groups.some((group) => userInfo.groups.includes(group));
                            })
                            .map((item) => {
                                const {
                                    text, icon, onClick, path,
                                } = item;
                                return (
                                    <ListItem
                                        key={text}
                                        button
                                        onClick={onClick}
                                        selected={path !== null && pathname === path}
                                    >
                                        {icon && <ListItemIcon>{icon}</ListItemIcon>}
                                        <ListItemText primary={text} />
                                    </ListItem>
                                );
                            })}
                    </List>

                    <Divider />
                    <List>
                        {catalogos
                            .filter((item) => {
                                // Only show if user has at least one of the required groups
                                if (!userInfo?.groups || !item.groups) {
                                    return false;
                                }
                                return item.groups.some((group) => userInfo.groups.includes(group));
                            })
                            .map((item) => {
                                const {
                                    text, icon, onClick, path,
                                } = item;
                                return (
                                    <ListItem
                                        key={text}
                                        button
                                        onClick={onClick}
                                        selected={path !== null && pathname === path}
                                    >
                                        {icon && <ListItemIcon>{icon}</ListItemIcon>}
                                        <ListItemText primary={text} />
                                    </ListItem>
                                );
                            })}
                    </List>
                    {userInfo?.groups && (userInfo.groups.includes('Administradores') || userInfo.groups.includes('Estandar')) && (
                        <>
                            <Divider />
                            <List>
                                <ListItem button onClick={handleClick} style={{ background: '#313131', color: 'white' }}>
                                    <ListItemIcon>
                                        <AssignmentIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary='Información Cargada' />
                                    {open ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                                <Collapse in={open} timeout='auto' unmountOnExit>
                                    <List component='div' disablePadding>
                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/gasolina')}
                                            selected={pathname === '/gasolina'}
                                        >
                                            <ListItemIcon>
                                                <LocalGasStationIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Gasolina' />
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/gps')}
                                            selected={pathname === '/gps'}
                                        >
                                            <ListItemIcon>
                                                <GpsFixedIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='GPS' />
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/casetas')}
                                            selected={pathname === '/casetas'}
                                        >
                                            <ListItemIcon>
                                                <CommuteIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Casetas' />
                                        </ListItem>
                                    </List>
                                </Collapse>
                            </List>
                        </>
                    )}
                    {userInfo?.groups && (userInfo.groups.includes('Administradores') || userInfo.groups.includes('Estandar')) && (
                        <>
                            <Divider />
                            <List>
                                <ListItem button onClick={handleClickLiq} style={{ background: '#313131', color: 'white' }}>
                                    <ListItemIcon>
                                        <AccountBalanceIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary='Liquidación' />
                                    {openLiq ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>

                                <Collapse in={openLiq} timeout='auto' unmountOnExit>
                                    <List component='div' disablePadding>

                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/liquidacionvi')}
                                            selected={pathname === '/liquidacionvi'}
                                        >
                                            <ListItemIcon>
                                                <AccountBalanceWalletIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Liquidación Viajes' />
                                        </ListItem>

                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/liquidacionop')}
                                            selected={pathname === '/liquidacionop'}
                                        >
                                            <ListItemIcon>
                                                <PaymentIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Liquidación Operadores' />
                                        </ListItem>

                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/liquidacionAdmin')}
                                            selected={pathname === '/liquidacionAdmin'}
                                        >
                                            <ListItemIcon>
                                                <AccountBalanceIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Pago Administrativos' />
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/referenciados')}
                                            selected={pathname === '/referenciados'}
                                        >
                                            <ListItemIcon>
                                                <AccountBalanceWalletIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Viajes Referenciados' />
                                        </ListItem>

                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/reporteUtilidad')}
                                            selected={pathname === '/reporteUtilidad'}
                                        >
                                            <ListItemIcon>
                                                <AccountBalanceWalletIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Reporte Utilidad' />
                                        </ListItem>

                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/gastosExtra')}
                                            selected={pathname === '/gastosExtra'}
                                        >
                                            <ListItemIcon>
                                                <AccountBalanceWalletIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Gastos Extra' />
                                        </ListItem>

                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/pagoOperadores')}
                                            selected={pathname === '/pagoOperadores'}
                                        >
                                            <ListItemIcon>
                                                <ReceiptIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Pagos Operadores' />
                                        </ListItem>

                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/pagoAdmin')}
                                            selected={pathname === '/pagoAdmin'}
                                        >
                                            <ListItemIcon>
                                                <ReceiptIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Historial Pago Administrativos' />
                                        </ListItem>

                                    </List>
                                </Collapse>
                            </List>
                        </>
                    )}
                    {userInfo?.groups && (userInfo.groups.includes('Administradores') || userInfo.groups.includes('Estandar')) && (
                        <>
                            <Divider />
                            <List>
                                <ListItem button onClick={handleClickTaller} style={{ background: '#313131', color: 'white' }}>
                                    <ListItemIcon>
                                        <BuildIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary='Taller de Mantenimiento' />
                                    {openTaller ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>

                                <Collapse in={openTaller} timeout='auto' unmountOnExit>
                                    <List component='div' disablePadding>
                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/mantenimiento')}
                                            selected={pathname === '/mantenimiento'}
                                        >
                                            <ListItemIcon>
                                                <LocalShippingOutlinedIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Mantenimiento' />
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/registroMateriales')}
                                            selected={pathname === '/registroMateriales'}
                                        >
                                            <ListItemIcon>
                                                <InventoryIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Registro Materiales' />
                                        </ListItem>
                                        {' '}
                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/historialMtto')}
                                            selected={pathname === '/historialMtto'}
                                        >
                                            <ListItemIcon>
                                                <ChecklistIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Historial Mantenimientos' />
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={classes.nested}
                                            onClick={() => history.push('/reporteMtto')}
                                            selected={pathname === '/reporteMtto'}
                                        >
                                            <ListItemIcon>
                                                <AssessmentIcon />
                                            </ListItemIcon>
                                            <ListItemText primary='Reporte Mantenimientos' />
                                        </ListItem>
                                    </List>
                                </Collapse>
                            </List>
                        </>
                    )}
                    {userInfo?.groups && (userInfo.groups.includes('Administradores') || userInfo.groups.includes('Bancos') || userInfo.groups.includes('Complementos')) && (
                        <>
                            <Divider />
                            <List>
                                <ListItem button onClick={handleClickControlBancos} style={{ background: '#313131', color: 'white' }}>
                                    <ListItemIcon>
                                        <SavingsIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary='Control Bancos' />
                                    {openControlBancos ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                                <Collapse in={openControlBancos} timeout='auto' unmountOnExit>
                                    <List component='div' disablePadding>
                                        {(userInfo.groups.includes('Administradores') || userInfo.groups.includes('Bancos')) && (
                                            <ListItem
                                                button
                                                className={classes.nested}
                                                onClick={() => history.push('/movimientos-bancarios')}
                                                selected={pathname === '/movimientos-bancarios'}
                                            >
                                                <ListItemIcon>
                                                    <ReceiptIcon />
                                                </ListItemIcon>
                                                <ListItemText primary='Movimientos' />
                                            </ListItem>
                                        )}
                                        {(userInfo.groups.includes('Administradores') || userInfo.groups.includes('Complementos')) && (
                                            <ListItem
                                                button
                                                className={classes.nested}
                                                onClick={() => history.push('/control-ingresos')}
                                                selected={pathname === '/control-ingresos'}
                                            >
                                                <ListItemIcon>
                                                    <AttachMoneyIcon />
                                                </ListItemIcon>
                                                <ListItemText primary='Control Ingresos' />
                                            </ListItem>
                                        )}
                                    </List>
                                </Collapse>
                            </List>
                        </>
                    )}
                </MUIDrawer>
            </Box>
        </div>
    );
}

export default withRouter(SideMenu);
